import React, { forwardRef } from 'react'
import { Input, type InputProps, useMedia, YStack } from 'tamagui'
import CobuText from './CobuText'
import type { DSColor } from '../types'

type CobuInputProps = Omit<InputProps, 'backgroundColor' | 'borderColor'> & {
  label?: string
  error?: string
  helperText?: string
  backgroundColor?: DSColor
  borderColor?: DSColor
  errorColor?: DSColor
}

const CobuInput = forwardRef<any, CobuInputProps>(
  (
    {
      label,
      error,
      helperText,
      backgroundColor = '$whiteTransparent70',
      borderColor = '$borderColor',
      errorColor = '$error',
      ...props
    },
    ref
  ) => {
    const media = useMedia()
    const inputSize = media.gtSm ? ('$12' as any) : ('$12' as any)
    const fontSize = media.gtSm ? ('$3' as any) : ('$2' as any)
    const padding = media.gtSm ? ('$3' as any) : ('$2' as any)
    return (
      <YStack gap="$1">
        {label ? (
          <CobuText variant="label" color="$color">
            {label}
          </CobuText>
        ) : null}

        <Input
          size={inputSize}
          fontSize={fontSize as any}
          borderRadius="$5"
          backgroundColor={backgroundColor as any}
          borderColor={(error ? errorColor : borderColor) as any}
          paddingLeft="$4"
          paddingRight="$4"
          padding={padding as any}
          placeholderTextColor="$colorMuted"
          {...props}
          ref={ref}
        />

        {error ? (
          <CobuText variant="caption" color={errorColor}>
            {error}
          </CobuText>
        ) : null}

        {!error && helperText ? (
          <CobuText variant="caption" color={'$colorSecondary' as any}>
            {helperText}
          </CobuText>
        ) : null}
      </YStack>
    )
  }
)

// No DOM elements in DS atoms to keep RN/web parity

export default CobuInput


